import { API, graphqlOperation } from 'aws-amplify';
import type { Account } from '~redux/account/actions/account';
import * as queries from '../graphql/queries';

export const getAccount = async (accountId: string): Promise<Account> => {
  const {
    data: { getAccount: account },
  } = await API.graphql<any>(
    graphqlOperation(queries.getAccount, { id: accountId })
  );
  return account;
};

export const generateRandomPassword = (length = 8) => {
  if (length < 8 || length > 20) {
    throw new Error('パスワードの長さは8〜20文字の間で指定してください');
  }

  const lowercase = 'abcdefghijklmnopqrstuvwxyz';
  const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const numbers = '0123456789';
  const symbols = '!@#$%^&*()_+-=[]{}|;:,.<>?';

  // すべての文字セットを結合
  const allChars = lowercase + uppercase + numbers + symbols;

  let password = '';

  // 少なくとも1つの小文字を追加
  password += lowercase.charAt(Math.floor(Math.random() * lowercase.length));

  // 少なくとも1つの大文字を追加
  password += uppercase.charAt(Math.floor(Math.random() * uppercase.length));

  // 少なくとも1つの数字を追加
  password += numbers.charAt(Math.floor(Math.random() * numbers.length));

  // 少なくとも1つの記号を追加
  password += symbols.charAt(Math.floor(Math.random() * symbols.length));

  // 残りの文字をランダムに追加
  for (let i = 4; i < length; i++) {
    password += allChars.charAt(Math.floor(Math.random() * allChars.length));
  }

  // パスワードをシャッフルする（Fisher-Yatesアルゴリズム）
  const passwordArray = password.split('');
  for (let i = passwordArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [passwordArray[i], passwordArray[j]] = [passwordArray[j], passwordArray[i]];
  }

  return passwordArray.join('');
};
